import React from "react";

const ProductTaxCard = ({ product }) => {
    if (
        !product?.tax_percent &&
        !product?.discount_percent &&
        !product?.warranty_period
    ) {
        return null;
    }

    return (
        <div className="card mb-4">
            <div className="card-header">
                <h5 className="mb-0">TAX & DISCOUNT</h5>
            </div>

            <div className="card-body">
                <div className="row">

                    <div className="col-md-4">
                        <strong>Tax:</strong>{" "}
                        {product?.tax_percent || "0"}%
                    </div>

                    <div className="col-md-4">
                        <strong>Discount:</strong>{" "}
                        {product?.discount_percent || "0"}%
                    </div>

                    <div className="col-md-4">
                        <strong>Warranty Period:</strong>{" "}
                        {product?.warranty_period || "-"}
                    </div>

                </div>
            </div>
        </div>
    );
};

export default ProductTaxCard;